<template>
    <div v-if="this.contrat">
      <div class="entete border-entete">
        <div class="is-paddingless section">
          <div class="level">
            <div class="level-left">
              <div class="columns is-gapless">
                <div class="column">
                  <h1 class="title is-size-3" >
                    {{ $t('ajoutMateriel.title') }}
                  </h1>
                  <breadcrumb :breadcrumb="breadcrumb"/>
                </div>
              </div>
            </div>
            <div class="level-right">
              <div class="buttons">
                <button class="button" @click="$router.go(-1)">
                  {{$t('general.button.return')}}
                </button>
                <button class="button is-addOrEdit mgl-10px" @click="saveMateriel">
                  {{$t('general.button.add')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <liste-patrimoine
        ref="materielSelector"
        :type-patrimoine="constantes.MATERIEL"
        :patrimoine-associated="getMaterielsAssociated"/>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import { SET_CONTRAT } from '@/store/modules/baux/contrat-mutation-type';
import listePatrimoine from '@/components/gabed/general/l_patrimoine';
import { MATERIEL } from '@/configuration/gabed/emplacement/emplacementConf';

const Contrat = createNamespacedHelpers('contrat');

export default {
  name: 'ajoutMateriel',
  components: {
    breadcrumb,
    listePatrimoine,
  },
  data() {
    return {
      constantes: {
        MATERIEL,
      },
      emplacement: [],
    };
  },
  methods: {
    ...Contrat.mapMutations({
      setContrat: SET_CONTRAT,
    }),
    async saveMateriel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const materielfsSelected = await this.$refs.materielSelector.loadMaterielsSelection();
        materielfsSelected.forEach((materiel) => {
          if (this.contrat?.contratsMateriels.find((materielInContrat) => {
            return materielInContrat.materielId === materiel.id;
          })) return;

          this.contrat.contratsMateriels.push({
            materiel: materiel,
            materielId: materiel.id,
            logo: null,
            isNew: true,
          });
        });
        await this.setContrat(this.contrat);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
        this.$router.go(-1);
      }
    },
  },
  computed: {
    ...Contrat.mapGetters({
      contrat: 'contrat',
    }),
    getMaterielsAssociated() {
      return this.contrat.contratsMateriels.map(contratsMateriel => contratsMateriel.materiel);
    },
    getPageRecherche() {
      return {
        current: 0,
        limit: 20,
      };
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('ajoutMateriel.breadcrumb.home'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('ajoutMateriel.breadcrumb.liste'), route: { name: 'l.baux.contrat' }, isActive: false },
        { title: this.$i18n.t('ajoutMateriel.breadcrumb.addContrat'), route: { name: 'm.baux.contrat-ajout' }, isActive: false },
        { title: this.$i18n.t('ajoutMateriel.breadcrumb.addMateriel'), route: '', isActive: true },
      ];
      if (this.contrat?.id) {
        output[2].title = this.$i18n.t('ajoutMateriel.breadcrumb.editContrat');
        output[2].route = { name: 'm.baux.contrat-edit', params: { id: this.contrat.id } };
      }
      return output;
    },
  },
  mounted() {
    if (!this.contrat) this.$router.go(-1);
    if (this.contrat) {
      this.contrat.isComingFromAjoutMateriel = true;
    }
  },
};
</script>
